/*
 * Cookie consent: window.TmConsent (vault 40 Platform/Consent banner.md — flows approved COOL 165, decisions COOL 166).
 *
 * - TmConsent.allowed('necessary'|'preferences'|'analytics'|'advertising'): our own code asks before it stores or sends
 *   anything (Flow 6). Without a stored choice: allowed in the notice region (advertising off for a Global Privacy Control
 *   browser), not allowed in the opt-in region or while the region is unknown.
 * - TmConsent.open('consent'|'details'|'about'|'summary'): the popup (app/cool-html/sections/consent/consent-popup.php).
 *   The footer's Cookie settings link opens the small widget ('summary') once a choice is saved, else Consent (Peter, COOL 173).
 * - The choice lives in the cookie tm_consent (host-only, 1 year, SameSite=Lax): {id, v, r, c:{p,a,m}, gpc, t}.
 *   Every choice goes to the consent log by sendBeacon (data-endpoint on the popup; empty = none), fire and forget.
 * - Google Consent Mode: defaults + the stored choice are set before GTM by sections/tracking/consent-default.php
 *   (window.tmConsentState); this file sends 'consent update' and tm_consent_update when the visitor chooses.
 * Region: EU27 + IS, LI, NO + GB + CH = opt-in (the popup opens on arrival), elsewhere = notice (no popup on arrival:
 * the footer links only, Peter COOL 172). Country from tmv-country, else tmVisitorStore.resolveCountry()
 * (/cdn-cgi/trace); no answer in 1.5 s = opt-in. ?tm_country (testing) counts only when it asks for the opt-in region:
 * a link never lifts the opt-in region's protection (COOL 167 review); a notice-region test sets tmv-country instead.
 * Keep VERSION and OPTIN in step with consent-default.php. Loaded first in the footer bundles: no dependencies at load.
 */
(function (w, d) {
    'use strict';

    var VERSION = 1;
    var COOKIE = 'tm_consent';
    var MODAL = '#c-consent-modal';
    var SUMMARY = '#c-consent-summary-modal'; // the small "Cookie settings" widget (a saved choice: the footer link opens it first)
    var OPTIN = ['at', 'be', 'bg', 'hr', 'cy', 'cz', 'dk', 'ee', 'fi', 'fr', 'de', 'gr', 'hu', 'ie', 'it', 'lv', 'lt', 'lu', 'mt', 'nl', 'pl', 'pt', 'ro', 'sk', 'si', 'es', 'se', 'is', 'li', 'no', 'gb', 'ch'];
    var LANGUAGES = ['en', 'da', 'de', 'es', 'fr', 'it', 'ja', 'nl', 'no', 'pt', 'sv'];
    var KEYS = { preferences: 'p', analytics: 'a', advertising: 'm' };
    var REGION_TIMEOUT_MS = 1500;

    // first-party storage of each category, deleted when the category is switched off (Flow 5.4). Third-party cookies
    // (on the vendors' own domains) expire on their own; the Cookie Policy says so.
    var STORAGE = {
        p: { cookies: ['tmv-name', 'tmv-email', 'tmv-phone'], prefixes: [], local: [], localPrefixes: [] },
        a: {
            cookies: ['_ga', '_gid', '_gat'],
            prefixes: ['_ga_', '_gat_', 'ph_'],
            local: ['tmJwtIdentifier', 'tmVisitorActions', 'coolLastTrackedUrl', 'cool-nav', 'tmv-tags'],
            localPrefixes: ['ph_', '__ph_']
        },
        m: {
            cookies: ['coolAttribution', 'is_from_g_ttd', '_fbp', '_fbc', '_ttp', '_tt_enable_cookie', '_uetsid', '_uetvid', '_uetmsclkid'],
            prefixes: ['_gcl_', '_gac_', 'ttcsid', '_uet', '_scid', 'FPGCL'],
            local: ['_uetsid', '_uetvid', '_uetsid_exp', '_uetvid_exp'],
            localPrefixes: ['_gcl_', 'tt_']
        }
    };

    var state = {
        stored: readStored(),
        region: null, // 'optin' | 'notice' once known
        gpc: detectGpc(),
        texts: null, // the translated texts, when the page is not in English
        textsLoad: null, // their fetch, once per page (loadTexts)
        known: false, // the choice or the region is known: TmConsent.ready() callbacks have run
        waiting: [],
        bound: false
    };

    function detectGpc() {
        try {
            return navigator.globalPrivacyControl === true;
        } catch (e) {
            return false;
        }
    }

    function isValid(record) {
        return !!record && typeof record === 'object' && !!record.c && typeof record.c === 'object'
            && typeof record.v === 'number' && typeof record.id === 'string' && /^[A-Za-z0-9_-]{8,64}$/.test(record.id)
            && (record.v === VERSION || (record.r === 'notice' && record.v < VERSION)); // a new version asks the opt-in region again
    }

    function readStored() {
        try {
            var match = /(?:^|;\s*)tm_consent=([^;]*)/.exec(d.cookie);
            if (!match) {
                return null;
            }
            var record = JSON.parse(decodeURIComponent(match[1]));
            return isValid(record) ? record : null;
        } catch (e) {
            return null;
        }
    }

    function writeStored(record) {
        var value = encodeURIComponent(JSON.stringify(record));
        // host-only (no domain), like the tmv- cookies: each brand domain asks once (Peter, COOL 165)
        d.cookie = COOKIE + '=' + value + '; path=/; max-age=' + (365 * 24 * 60 * 60) + '; SameSite=Lax' + (w.location.protocol === 'https:' ? '; Secure' : '');
    }

    function newId() {
        var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
        var id = '';
        try {
            var bytes = new Uint8Array(22);
            w.crypto.getRandomValues(bytes);
            for (var i = 0; i < bytes.length; i++) {
                id += alphabet.charAt(bytes[i] & 63);
            }
        } catch (e) {
            id = '';
            for (var j = 0; j < 22; j++) {
                id += alphabet.charAt(Math.floor(Math.random() * 64));
            }
        }
        return id;
    }

    // the country without waiting: ?tm_country when it asks for the opt-in region (testing; a link never lifts the opt-in
    // region's protection, COOL 167 review), else tmv-country (Cloudflare's answer on an earlier page)
    function knownCountry() {
        try {
            var query = /[?&]tm_country=([A-Za-z]{2})(?:&|#|$)/.exec(w.location.search);
            if (query && OPTIN.indexOf(query[1].toLowerCase()) > -1) {
                return query[1].toLowerCase();
            }
            var cookie = /(?:^|;\s*)tmv-country=([A-Za-z]{2})(?:;|$)/.exec(d.cookie);
            return cookie ? cookie[1].toLowerCase() : '';
        } catch (e) {
            return w.tmConsentState && w.tmConsentState.country ? w.tmConsentState.country : ''; // what the <head> script read (consent-default.php)
        }
    }

    function regionOf(country) {
        if (!country) {
            return null;
        }
        return OPTIN.indexOf(String(country).toLowerCase()) > -1 ? 'optin' : 'notice';
    }

    // the region, looking the country up when it is not known yet; the opt-in region when there is no answer in 1.5 s
    function resolveRegion() {
        var region = regionOf(knownCountry());
        if (region) {
            return Promise.resolve(region);
        }
        return new Promise(function (resolve) {
            var settled = false;
            var finish = function (value) {
                if (!settled) {
                    settled = true;
                    resolve(value || 'optin');
                }
            };
            setTimeout(function () { finish('optin'); }, REGION_TIMEOUT_MS);
            try {
                // false: Cloudflare's answer, never the ?tm_country override (knownCountry())
                var lookup = w.tmVisitorStore && typeof w.tmVisitorStore.resolveCountry === 'function' ? w.tmVisitorStore.resolveCountry(false) : Promise.resolve('');
                lookup.then(function (country) { finish(regionOf(country)); }, function () { finish('optin'); });
            } catch (e) {
                finish('optin');
            }
        });
    }

    function currentRegion() {
        return state.region || regionOf(knownCountry()) || (state.stored ? state.stored.r : null);
    }

    // what applies without a stored choice: everything in the notice region (advertising off for GPC), nothing otherwise
    function defaultChoice(region) {
        if (region === 'notice') {
            return { p: true, a: true, m: !state.gpc };
        }
        return { p: false, a: false, m: false };
    }

    function allowed(category) {
        if (category === 'necessary') {
            return true;
        }
        var key = KEYS[category];
        if (!key) {
            return false;
        }
        if (state.stored) {
            return !!state.stored.c[key];
        }
        return !!defaultChoice(currentRegion())[key];
    }

    // a Global Privacy Control browser in the notice region that kept the default (OK, the X, or the same switches:
    // everything but advertising) gets Consent Mode's GPC default of the <head> script (consent-default.php, Flow 1.3):
    // ad_storage stays granted, only ad_user_data + ad_personalization are denied. Keep in step with consent-default.php.
    function isGpcDefault(record) {
        return !!record && record.r === 'notice' && !!record.gpc && !!record.c.p && !!record.c.a && !record.c.m;
    }

    function gtagUpdate(choice, keepAdStorage) {
        try {
            w.dataLayer = w.dataLayer || [];
            if (typeof w.gtag !== 'function') {
                w.gtag = function () { w.dataLayer.push(arguments); };
            }
            var g = 'granted', n = 'denied';
            w.gtag('consent', 'update', {
                analytics_storage: choice.a ? g : n,
                ad_storage: (choice.m || keepAdStorage) ? g : n,
                ad_user_data: choice.m ? g : n, // GPC: off unless the visitor switched Advertising on themselves
                ad_personalization: choice.m ? g : n
            });
        } catch (e) {}
    }

    // ----- first-party storage removal on withdrawal -----
    function expireCookie(name) {
        var expired = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0; path=/';
        d.cookie = expired; // host-only
        var parts = w.location.hostname.split('.');
        for (var i = 0; i < parts.length - 1; i++) { // the host and each parent domain (www.example.com, example.com)
            d.cookie = expired + '; domain=' + parts.slice(i).join('.');
            d.cookie = expired + '; domain=.' + parts.slice(i).join('.');
        }
    }

    function removeStorage(key) {
        var spec = STORAGE[key];
        if (!spec) {
            return;
        }
        try {
            var names = d.cookie.split(';').map(function (pair) { return pair.split('=')[0].trim(); });
            names.forEach(function (name) {
                if (!name) {
                    return;
                }
                var match = spec.cookies.indexOf(name) > -1 || spec.prefixes.some(function (prefix) { return name.indexOf(prefix) === 0; });
                if (match) {
                    expireCookie(name);
                }
            });
        } catch (e) {}
        try {
            var storage = w.localStorage;
            spec.local.forEach(function (name) { storage.removeItem(name); });
            for (var i = storage.length - 1; i >= 0; i--) {
                var itemName = storage.key(i);
                if (itemName && spec.localPrefixes.some(function (prefix) { return itemName.indexOf(prefix) === 0; })) {
                    storage.removeItem(itemName);
                }
            }
        } catch (e) {}
    }

    // ----- the consent log -----
    function endpoint() {
        var root = d.querySelector('[data-tm-consent]');
        return root ? (root.getAttribute('data-endpoint') || '') : '';
    }

    function beacon(record, action) {
        try {
            var url = endpoint();
            if (!url || !navigator.sendBeacon) {
                return;
            }
            // a checkout or booking link carries its token in the path (/booking/<id>/<token>/): it stays on the page
            // (cool-platform's redactPath stores the same ':token'; COOL 167 review)
            var path = (w.location.pathname || '/').replace(/[^\x21-\x7E]/g, function (ch) { return encodeURIComponent(ch); })
                .replace(/\/[0-9a-f]{32}(?=\/|$)/gi, '/:token').slice(0, 512);
            navigator.sendBeacon(url, JSON.stringify({ // a string body: text/plain, no preflight
                id: record.id,
                v: record.v,
                r: record.r,
                a: action,
                c: { p: !!record.c.p, a: !!record.c.a, m: !!record.c.m },
                gpc: !!record.gpc,
                t: record.t,
                host: String(w.location.hostname || '').toLowerCase(),
                path: path || '/'
            }));
        } catch (e) {}
    }

    // ----- saving a choice -----
    function save(choice, action, logAs) { // logAs: the logged action whatever came before (Deny and Withdraw = deny)
        var before = { p: allowed('preferences'), a: allowed('analytics'), m: allowed('advertising') };
        var hadChoice = !!state.stored;
        var record = {
            id: hadChoice ? state.stored.id : newId(),
            v: VERSION,
            r: currentRegion() || 'optin',
            c: { p: !!choice.p, a: !!choice.a, m: !!choice.m },
            gpc: state.gpc,
            t: Date.now()
        };
        try {
            writeStored(record);
        } catch (e) {}
        state.stored = record;
        if (w.tmConsentState) {
            w.tmConsentState.choice = { p: record.c.p, a: record.c.a, m: record.c.m };
            w.tmConsentState.r = record.r;
        }

        gtagUpdate(record.c, isGpcDefault(record));
        try {
            w.dataLayer.push({ event: 'tm_consent_update', tm_consent: { preferences: record.c.p, analytics: record.c.a, advertising: record.c.m, region: record.r } });
        } catch (e) {}

        ['p', 'a', 'm'].forEach(function (key) {
            if (!record.c[key]) {
                removeStorage(key);
            }
        });

        // advertising given later in the visit: attribution from the current URL only (earlier landing parameters are lost)
        if (record.c.m && !before.m) {
            try {
                if (w.tmVisitorStore) { w.tmVisitorStore.setAttributionCookies(); }
                if (w.tmDocumentReady) { w.tmDocumentReady.trafficSourceLog(); }
            } catch (e) {}
        }

        beacon(record, logAs || (hadChoice ? 'change' : action));
        try {
            if (w.jQuery) { w.jQuery(d).trigger('tmConsentChanged', [record]); }
        } catch (e) {}
        return record;
    }

    // ----- the popup -----
    function root() {
        return d.querySelector('[data-tm-consent]');
    }

    function modal(id) {
        if (typeof w.Modal === 'undefined' && typeof Modal === 'undefined') {
            return null;
        }
        var M = typeof w.Modal !== 'undefined' ? w.Modal : Modal; // modal.js declares a global class (not on window)
        id = id || MODAL;
        return M.instance(id) || M.add(id);
    }

    function all(selector, scope) {
        return Array.prototype.slice.call((scope || d).querySelectorAll(selector));
    }

    function setHidden(el, hidden) {
        if (el) {
            el.classList.toggle('c-hidden', !!hidden);
        }
    }

    function switchFor(category) {
        var r = root();
        return r ? r.querySelector('input[name="tm_consent_' + category + '"]') : null;
    }

    function setSwitches(choice) {
        ['preferences', 'analytics', 'advertising'].forEach(function (category) {
            var input = switchFor(category);
            if (input) {
                input.checked = !!choice[KEYS[category]];
            }
        });
    }

    function readSwitches() {
        var choice = {};
        ['preferences', 'analytics', 'advertising'].forEach(function (category) {
            var input = switchFor(category);
            choice[KEYS[category]] = !!(input && input.checked);
        });
        return choice;
    }

    function activeTab() {
        var r = root();
        var active = r ? r.querySelector('#tm-consent-tabs .c-tabs-item-active') : null;
        return active ? active.getAttribute('data-tab-item-key') : 'tab-1';
    }

    // the footer that goes with the tab: Details = Deny · Allow selection · Allow all; the others = the region's pair or trio
    function showFooter() {
        var r = root();
        if (!r) {
            return;
        }
        var region = currentRegion() === 'notice' ? 'notice' : 'optin';
        var wanted = activeTab() === 'tab-2' ? 'details' : region;
        all(MODAL + ' [data-tmc-footer]', r).forEach(function (el) { // the main popup's footers (the widget has its own)
            setHidden(el, el.getAttribute('data-tmc-footer') !== wanted);
        });
    }

    // the same tab switching as the Language/Currency popup (main.js #langauge-currency), for this popup's ids
    function selectTab(key) {
        var r = root();
        if (!r) {
            return;
        }
        all('#tm-consent-tabs .c-tabs-item', r).forEach(function (tab) {
            tab.classList.toggle('c-tabs-item-active', tab.getAttribute('data-tab-item-key') === key);
        });
        all('.tm-consent-tab .c-tab-navigation-content', r).forEach(function (content) {
            setHidden(content, content.id !== 'tm-consent-' + key);
        });
        showFooter();
        updateFade();
    }

    function formatDate(time, withZone) {
        try {
            var options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
            if (withZone) {
                options.timeZoneName = 'short';
            }
            return new Date(time).toLocaleString(language() === 'en' ? undefined : language(), options);
        } catch (e) {
            return new Date(time).toISOString();
        }
    }

    function fillRegion() {
        var r = root();
        if (!r) {
            return;
        }
        var region = currentRegion() === 'notice' ? 'notice' : 'optin';
        all('[data-tmc-region]', r).forEach(function (el) {
            setHidden(el, el.getAttribute('data-tmc-region') !== region);
        });
        setHidden(r.querySelector('[data-tmc-gpc]'), !state.gpc);
        var choiceLine = r.querySelector('[data-tmc-choice]');
        if (choiceLine) {
            setHidden(choiceLine, !state.stored);
            if (state.stored) {
                choiceLine.querySelector('[data-tmc-id]').textContent = state.stored.id;
                choiceLine.querySelector('[data-tmc-date]').textContent = formatDate(state.stored.t, true); // with the zone, as the widget (COOL 170)
            }
        }
    }

    function open(tab) {
        var m = modal();
        if (!m) {
            return false;
        }
        bind();
        loadTexts(); // a translated page's texts: fetched the first time the popup shows (start() when it opens on arrival)
        var region = currentRegion();
        var choice = state.stored ? state.stored.c : defaultChoice(region);
        setSwitches(choice);
        fillRegion();
        // a choice is required in the opt-in region on the first visit: no X (Escape and the overlay never close it)
        if (state.stored || region === 'notice') {
            m.showCloseIcon();
        }
        else {
            m.hideCloseIcon();
        }
        var key = tab === 'details' ? 'tab-2' : (tab === 'about' ? 'tab-3' : 'tab-1');
        m.open(key); // Modal.open clicks that tab: selectTab() runs from the click
        selectTab(key);
        setTimeout(updateFade, 0);
        setTimeout(updateFade, 600); // after the slide-in
        return true;
    }

    function close() {
        var m = modal();
        if (m) {
            m.close();
        }
    }

    // ----- the fade above the footer line while there is more to scroll (Peter, COOL 166 r1t; the look is the tour index
    // pages' text fade, styles PR sections/consent.scss): tm-consent-more on the modal while its body is not at the end -----
    function updateFade() {
        [MODAL, SUMMARY].forEach(function (id) {
            var content = d.querySelector(id + ' .c-modal-content');
            var body = content ? content.querySelector('.c-modal-body') : null;
            if (body) {
                content.classList.toggle('tm-consent-more', body.scrollHeight - body.clientHeight - body.scrollTop > 2);
            }
        });
    }

    function watchFade() {
        all(MODAL + ' .c-modal-body, ' + SUMMARY + ' .c-modal-body').forEach(function (body) {
            body.addEventListener('scroll', updateFade, { passive: true });
        });
        var r = root();
        if (r) { // an accordion opening or closing (max-height transition), a tab, the Show details card
            r.addEventListener('transitionend', updateFade);
            r.addEventListener('click', function () { setTimeout(updateFade, 0); });
        }
        w.addEventListener('resize', updateFade);
    }

    // ----- the small "Cookie settings" widget (Peter, COOL 166 r1q) -----
    function setSummaryDetails(open) {
        var r = root();
        var toggle = r.querySelector('[data-tmc-summary-toggle]');
        if (!toggle) {
            return;
        }
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        setHidden(toggle.querySelector('[data-tmc-t="show_details"]'), open);
        setHidden(toggle.querySelector('[data-tmc-t="hide_details"]'), !open);
        var icon = toggle.querySelector('i');
        if (icon) {
            icon.classList.toggle('fa-chevron-down', !open);
            icon.classList.toggle('fa-chevron-up', open);
        }
        setHidden(r.querySelector('[data-tmc-summary-card]'), !open);
    }

    function openSummary() {
        var r = root();
        var m = modal(SUMMARY);
        if (!r || !m || !state.stored || !r.querySelector(SUMMARY)) {
            return open('details');
        }
        bind();
        loadTexts();
        all('[data-tmc-state]', r).forEach(function (el) { // lock (necessary), check (allowed) or xmark (denied)
            var category = el.getAttribute('data-tmc-state');
            var item = el.closest('.c-list-with-icons-list-item');
            var icon = item ? item.querySelector('i') : null;
            if (!icon || category === 'necessary') {
                return;
            }
            var on = !!state.stored.c[KEYS[category]];
            icon.classList.toggle('fa-check', on);
            icon.classList.toggle('fa-xmark', !on);
        });
        r.querySelector('[data-tmc-summary-date]').textContent = formatDate(state.stored.t, true);
        r.querySelector('[data-tmc-summary-id]').textContent = state.stored.id;
        setSummaryDetails(false);
        m.open();
        setTimeout(updateFade, 0);
        setTimeout(updateFade, 600);
        return true;
    }

    function closeSummary() {
        var m = modal(SUMMARY);
        if (m) {
            m.close();
        }
    }

    function act(action) {
        switch (action) {
            case 'deny': // logged as deny even after an earlier choice (COOL 170)
                save({ p: false, a: false, m: false }, 'deny', 'deny');
                close();
                break;
            case 'allow_all':
                save({ p: true, a: true, m: true }, 'allow_all');
                close();
                break;
            case 'allow_selection':
                save(readSwitches(), 'allow_selection');
                close();
                break;
            case 'ok':
                save(defaultChoice('notice'), 'ok');
                close();
                break;
            case 'customize':
            case 'cookie_settings':
                selectTab('tab-2');
                break;
            case 'withdraw': // the widget: Necessary only, as Deny (logged as deny, the log has no other value for it)
                save({ p: false, a: false, m: false }, 'deny', 'deny');
                closeSummary();
                break;
            case 'change': // the widget: the main popup again on the Consent tab, the saved choice in the switches (Peter, COOL 174; was Details, COOL 172)
                closeSummary();
                open('consent');
                break;
        }
    }

    // ----- texts in the page's language -----
    function language() {
        var lang = String(d.documentElement.getAttribute('lang') || 'en').toLowerCase().split(/[-_]/)[0];
        if (lang === 'nb' || lang === 'nn') {
            lang = 'no';
        }
        return LANGUAGES.indexOf(lang) > -1 ? lang : 'en';
    }

    function fillTemplate(el, template, texts) {
        var links = {};
        all('a[data-tmc-link]', el).forEach(function (a) { links[a.getAttribute('data-tmc-link')] = a; });
        var values = {}; // no plain-value placeholders in the texts today: only links
        while (el.firstChild) {
            el.removeChild(el.firstChild);
        }
        template.split(/(\{[a-z_]+\})/).forEach(function (part) {
            if (!part) {
                return;
            }
            var match = /^\{([a-z_]+)\}$/.exec(part);
            if (match && links[match[1]]) {
                var link = links[match[1]];
                if (typeof texts['link_' + match[1]] === 'string') {
                    link.textContent = texts['link_' + match[1]];
                }
                el.appendChild(link);
            }
            else if (match && Object.prototype.hasOwnProperty.call(values, match[1])) {
                el.appendChild(d.createTextNode(values[match[1]]));
            }
            else {
                el.appendChild(d.createTextNode(part));
            }
        });
    }

    function applyTexts(texts) {
        var r = root();
        if (!r || !texts) {
            return;
        }
        all('[data-tmc-t]', r).forEach(function (el) {
            var text = texts[el.getAttribute('data-tmc-t')];
            if (typeof text !== 'string') {
                return;
            }
            if (text.indexOf('{') > -1) {
                fillTemplate(el, text, texts);
            }
            else {
                el.textContent = text;
            }
        });
        var tabKeys = ['tab_consent', 'tab_details', 'tab_about'];
        all('#tm-consent-tabs .c-tabs-item', r).forEach(function (tab, i) {
            if (typeof texts[tabKeys[i]] === 'string') {
                tab.textContent = texts[tabKeys[i]];
                tab.setAttribute('title', texts[tabKeys[i]]);
            }
        });
        all('[data-tmc-locked]', r).forEach(function (el) { // Necessary's alert text
            if (typeof texts.necessary_locked === 'string') {
                el.setAttribute('data-tmc-locked', texts.necessary_locked);
            }
        });
        ['necessary', 'preferences', 'analytics', 'advertising'].forEach(function (category) { // each switch's name for screen readers
            var input = switchFor(category);
            if (input && typeof texts['cat_' + category] === 'string') {
                input.setAttribute('aria-label', texts['cat_' + category]);
            }
        });
        // the footer links sit outside the popup: GTranslate translates them with the page
    }

    // a translated page's texts, fetched once per page and only when the popup may show (start(), open(), openSummary()):
    // Cloudflare does not cache .json, so every fetch reaches the server (COOL 167 review)
    function loadTexts() {
        if (state.textsLoad) {
            return state.textsLoad;
        }
        var lang = language();
        if (lang === 'en' || typeof w.fetch !== 'function') {
            return Promise.resolve(null);
        }
        state.textsLoad = fetch('/app/consent/i18n/' + lang + '.json', { credentials: 'same-origin' })
            .then(function (response) { return response.ok ? response.json() : null; })
            .then(function (texts) {
                state.texts = texts && typeof texts === 'object' ? texts : null;
                applyTexts(state.texts);
                return state.texts;
            })
            .catch(function () { return null; }); // English stays
        return state.textsLoad;
    }

    // ----- wiring -----
    function bind() {
        if (state.bound) {
            return;
        }
        state.bound = true;
        watchFade();
        // the Details tab's switches and "Learn more about this provider" links sit in accordion headers
        // (components/accordion): a click on them is not a click on the header, which would open or close it
        // (tm-elements.js cAccordion binds the header itself, so stopping the click here keeps it from getting there)
        var r = root();
        all('.tm-consent-switch, .tm-consent-provider-link', r || d.createElement('div')).forEach(function (el) {
            el.addEventListener('click', function (e) { e.stopPropagation(); });
        });
        // Necessary's switch is on in full colour (not disabled, Peter COOL 166 r1i): a click or Space does not turn it off
        // but shows the browser's alert, as Cookiebot ("Mandatory – can't be turned off." + the Necessary text)
        all('[data-tmc-locked] input[type="checkbox"]', r || d.createElement('div')).forEach(function (input) {
            input.checked = true;
            input.setAttribute('aria-disabled', 'true');
            input.addEventListener('click', function (e) {
                e.preventDefault(); // the box stays checked
                var lock = input.closest('[data-tmc-locked]');
                var text = r.querySelector('[data-tmc-t="cat_necessary_text"]');
                var message = (lock.getAttribute('data-tmc-locked') + ' ' + (text ? text.textContent : '')).trim();
                setTimeout(function () { // after the click is undone, so the switch shows on behind the alert
                    input.checked = true;
                    try { w.alert(message); } catch (err) {}
                }, 0);
            });
        });
        d.addEventListener('click', function (e) {
            var target = e.target && e.target.closest ? e.target : null;
            if (!target) {
                return;
            }
            var opener = target.closest('[data-tm-consent-open]');
            if (opener) {
                e.preventDefault();
                var which = opener.getAttribute('data-tm-consent-open');
                if (which === 'details') { // Cookie settings: the small widget once a choice is saved, else the popup on Consent (Peter, COOL 173)
                    if (state.stored) {
                        openSummary();
                    }
                    else {
                        open('consent');
                    }
                }
                else {
                    open(which);
                }
                return;
            }
            var r = root();
            if (!r || !r.contains(target)) {
                return;
            }
            if (target.closest('[data-tmc-summary-toggle]')) {
                e.preventDefault();
                setSummaryDetails(target.closest('[data-tmc-summary-toggle]').getAttribute('aria-expanded') !== 'true');
                return;
            }
            var button = target.closest('[data-tmc-action]');
            if (button) {
                e.preventDefault();
                act(button.getAttribute('data-tmc-action'));
                return;
            }
            var tab = target.closest('#tm-consent-tabs .c-tabs-item');
            if (tab) {
                selectTab(tab.getAttribute('data-tab-item-key'));
            }
        });
        d.addEventListener('keydown', function (e) { // the tabs are focusable (tabindex 0): Enter / Space choose one
            var tab = e.target && e.target.closest ? e.target.closest('#tm-consent-tabs .c-tabs-item') : null;
            if (tab && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                selectTab(tab.getAttribute('data-tab-item-key'));
            }
        });
        if (w.jQuery) {
            // the X (notice region, or a choice already made): with no choice yet, closing counts as OK
            w.jQuery(d).on('tmModal_closed_' + MODAL, function () {
                if (!state.stored && currentRegion() === 'notice') {
                    save(defaultChoice('notice'), 'ok');
                }
            });
        }
    }

    // run what waits for the choice or the region (the first visit's region comes from /cdn-cgi/trace, up to 1.5 s)
    function markKnown() {
        if (state.known) {
            return;
        }
        state.known = true;
        var waiting = state.waiting;
        state.waiting = [];
        waiting.forEach(function (callback) {
            try {
                callback();
            } catch (e) {}
        });
    }

    function ready(callback) {
        if (typeof callback !== 'function') {
            return;
        }
        if (state.known) {
            callback();
        }
        else {
            state.waiting.push(callback);
        }
    }

    function start() {
        var hasPopup = !!root(); // no popup on private pages: TmConsent.allowed() and ready() still answer
        if (hasPopup) {
            bind();
            // the popup may open on arrival (no choice saved; the opt-in region, or not known yet): its texts now, so it
            // opens in the page's language. Otherwise they wait until the visitor opens it.
            if (!state.stored && regionOf(knownCountry()) !== 'notice') {
                loadTexts();
            }
        }
        else { // a private page keeps the site footer but has no popup: its consent links would do nothing
            all('[data-tm-consent-open]').forEach(function (link) { setHidden(link.closest('li') || link, true); });
        }
        if (state.stored) {
            state.region = regionOf(knownCountry()) || state.stored.r;
            markKnown();
            return;
        }
        resolveRegion().then(function (region) {
            state.region = region;
            if (region === 'optin') {
                gtagUpdate({ p: false, a: false, m: false }); // whatever Google's own geo said: nothing until the visitor chooses
            }
            markKnown();
            if (region !== 'optin' || !hasPopup || w.self !== w.top) {
                return; // the notice region gets no popup on arrival, only the footer's Cookie settings link (Peter, COOL 172); inside a frame (checkout shown in a popup) the page around it asks
            }
            open('consent');
        });
    }

    w.TmConsent = {
        version: VERSION,
        allowed: allowed,
        ready: ready, // callback once the choice or the region is known (at once on most page views)
        known: function () { return state.known; }, // false while a first visit's region is still being looked up
        open: function (tab) { return tab === 'summary' ? openSummary() : open(tab || 'consent'); },
        choice: function () { return state.stored ? { id: state.stored.id, preferences: !!state.stored.c.p, analytics: !!state.stored.c.a, advertising: !!state.stored.c.m, region: state.stored.r, gpc: !!state.stored.gpc, time: state.stored.t } : null; },
        region: currentRegion
    };

    // a stored choice, or a country already known (?tm_country, tmv-country): ready() callbacks run at once, in page order
    if (state.stored || regionOf(knownCountry())) {
        state.region = regionOf(knownCountry()) || state.stored.r;
        markKnown();
    }

    if (d.readyState === 'loading') {
        d.addEventListener('DOMContentLoaded', start);
    }
    else {
        start();
    }
})(window, document);
